import { DIC } from "@/const/dic";
 const businessLine =[
  { label: "防水", value: "WATERPROOF" },
  { label: "吊顶", value: "HANG_CEILING" },
  { label: "净水", value: "PURE_WATER" },
  { label: "管道", value: "PIPELINE" },
  { label: "地暖", value: "ENGINEERING" },
]
export const afterSalesOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  // align: 'center',
  index: false,
  selection: true,
  menu: true,
  menuType: "menu",
  // menuType:"text",
  page: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  viewBtn: false,
  menuWidth: "180",
  labelWidth: "200",
  defaultSort: {
    prop: "createTime",
    order: "descending",
  },
  column: [
    {
      label: "客户姓名",
      search: true,
      prop: "customName",
      type: "input",
      overHidden: true,
      editVisdiplay: false,
    },
    {
      label: "客户电话",
      search: true,
      prop: "customMobile",
      type: "input",
      overHidden: true,
      editVisdiplay: false,
    },
    {
      label: "客户地址",
      search: true,
      prop: "customAddress",
      type: "input",
      overHidden: true,
      editVisdiplay: false,
    },
    {
      label: "故障现象",
      prop: "faultPhenomenon",
      type: "input",
      search: false,
      overHidden: true,
      editVisdiplay: false,
    },
    {
      label: "故障照片",
      prop: "faultPhotos",
      type: "upload",
      solt: true,
      formsolt: true,
      imgWidth: 50,
      listType: "picture-img",
      editVisdiplay: false,
    },
    {
      label: "故障视频",
      prop: "videoUrl",
      solt: true,
      formsolt: true,
      type: "upload",
      imgWidth:100,
      listType: "picture-img",
      editVisdiplay: false,
    },
    // overinsuredFlag
    {
      label: "是否过保",
      prop: "overinsuredFlag",
      type: "radio",
      dicData: [
        { label: "是", value: "YES" },
        { label: "否", value: "NO" },
        { label: "待确认", value: "PENDING" },
      ],
      search: false
    },
    {
      label: "服务工程师",
      prop: "engineerName",
      type: "input",
      search: true,
      overHidden: true,
      editVisdiplay: false,
    },
    {
      label: "服务工程师",
      prop: "engineer",
      type: "input",
      hide: true,
      formsolt: true,
      overHidden: true,
    },
    {
      label: "工程师电话",
      prop: "engineerMobile",
      type: "input",
      search: true,
      overHidden: true,
      editVisdiplay: false,
    },
    // 服务类型
    {
      label: "服务类型",
      prop: "businessLine",
      type: "select",
      dicData: businessLine,
      search: true,
    },
    {
      label: "服务项目",
      search: true,
      prop: "goodsName",
      formsolt: true,
      overHidden: true,
      viewVisdiplay: false,
    },
    {
      label:"是否提货",
      prop:"delivery",
      type:"radio",
      dicData:[
        {label:"是",value:0},
        {label:"否",value:1}
      ]
    },
    {
      label: "前仓",
      prop: "warehouseName",
      type: "input",
      search: true,
      formsolt: true,
      editVisdiplay: true,
      span: 12,
    },
    {
      label: "提货照片",
      prop: "deliveryUrl",
      type: "upload",
      solt: true,
      imgWidth: 50,
      listType: "picture-img",
      editVisdiplay: false,
    },
    {
      label: "状态",
      prop: "status",
      type: "select",
      search: true,
      solt: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    // reserveTime服务时间
    {
      label: "服务时间",
      prop: "reserveTime",
      type: "datetime",
      format: "yyyy-MM-dd hh:mm:ss",
      valueFormat: "yyyy-MM-dd hh:mm:ss",
      search: false,
    },
    {
      label: "报单时间",
      prop: "createTime",
      type: "datetime",
      format: "yyyy-MM-dd hh:mm:ss",
      valueFormat: "yyyy-MM-dd hh:mm:ss",
      overHidden: true,
      addVisdiplay: false,
      viewVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "报单人",
      prop: "createBy",
      overHidden: true,
      viewVisdiplay: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    // 备注
    {
      label: "备注",
      prop: "remarks",
      type: "input",
      search: false,
      overHidden: true,
      addVisdiplay: false,
      viewVisdiplay: false,
      editVisdiplay: false,
    },
    // 拒绝原因
    {
      label: "拒绝原因",
      prop: "reject",
      type: "input",
      search: false,
      overHidden: true,
      addVisdiplay: false,
      viewVisdiplay: false,
      editVisdiplay: false,
    }
  ],
};
